export enum LocalStorageKeys {
    Token = 'NDD360Token',
    LastLogin = 'NDD360LastLogin',
    CurrentLanguage = 'NDD360CurrentLang',
    AccountType = 'NDD360AccountType',
    RegionalSettings = 'NDD360RegionalSettings',
    PoliciesQuotasManagement = 'NDD360PoliciesQuotasManagement',
    AllowedPoliciesLicense = 'NDD360AllowedPoliciesLicense',
    Resources = 'NDD360Resources',
    CurrencyCulture = 'NDD360IntlCurrencyCulture',
    DecimalPlaces = 'NDD360DecimalPlaces',
}
